import { HeroSection } from "@/components/home/hero-section";
import { TodayStrip } from "@/components/home/today-strip";
import { ToolsSection } from "@/components/home/tools-section";
import { AiBanner } from "@/components/home/ai-banner";
// Phase 3: BlogStrip + LibraryStrip — disabled until /blog and /thu-vien land
// import { BlogStrip } from "@/components/home/blog-strip";
// import { LibraryStrip } from "@/components/home/library-strip";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <TodayStrip />
      <ToolsSection />
      <AiBanner />
    </>
  );
}
